<template>
<div class="stage-outer" ref="stage">
  <div class="stage" v-scrollanim>
    <canvas ref="canvas" />
  </div>
  <div class="svg-logo" v-scrollanim>
    <svgLogo3d  />
  </div>
</div>
</template>

<script>
import StageScene from './StageScene'
import svgLogo3d from "@/svg/svgLogo3d"

let stage

export default {
  name: "Stage",
  data() {
    return {
      wWidth: window.innerWidth,
      wHeight: window.innerHeight,
      sWidth: null,
      sHeight: null
    }
  },
  created() {
    window.addEventListener('resize', this.onResize, false)
  },
  beforeUnload() {
    window.removeEventListener('resize', this.onResize, false)
  },
  mounted() {
    stage = new StageScene()
    stage.init(this.$refs.canvas, {
      width: window.innerWidth, 
      height: this.$refs.stage.clientHeight,
      onIntroComplete: ()=> {
        this.$emit('introComplete')
      },
    })
  },
  methods: {
    onResize() {
      // TODO : 불필요한 요청수를 제거하기 위한 debounce
      stage.onResize({
        width: window.innerWidth,
        height: this.$refs.stage?.offsetHeight
      })
    },
  },
  components: {
    svgLogo3d
  }
};
</script>


<style scoped lang="scss">
.stage-outer {
  --stage-height: 515px;
  position: relative;
  width: 100%;
  height: var(--stage-height);
  @media screen and (max-width: 580px) {
    --stage-height: 400px;
  }
  @media screen and (max-width: 420px) {
    --stage-height: 320px;
  }
}
.stage {
  position: relative;
  width: 100%;
  height: 100%;
  &:before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: var(--stage-height);
    content: '';
    background: linear-gradient(180deg, #000 0%, transparent 77.92%);
    z-index: 9;
    pointer-events: none;
  }
  canvas {
    margin: 0 auto;
  }
}


.svg-logo {
  position: absolute;
  top: 30px;
  left: 50%;
  z-index: 15;
  height: 160px;
  width: 224px;
  display: block;
  margin-left: -112px + 25px;
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: 940px) {
    top: 50%;
    left: 50%;
    margin-left: auto;
    transform: translate3d(-35%, -125%, 0);
    width: 25%;
    height: auto;
  }
}


canvas {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  max-width: 100% !important;
  background-color: black;
}

.svg-logo.before-enter {
  opacity: 0;
  transition: 1s ease-in opacity;
  transition-delay: 1.3s;
  transform-origin: 40% 100%;
}
.svg-logo.enter {
  opacity: 1;
}
@keyframes bobUpDown {
    0% { transform: translate3d(0, 0, 0); }
    100% { transform: translate3d(0, -10px, 0); }
}

.stage.before-enter {
  opacity: 0;
  transform: translate3d(0, 10%, 0);
  transition: 2s ease-in opacity, 2s ease-in transform;
}

.stage.enter {
  opacity: 1;  
  transform: translate3d(0, 0%, 0);
}

</style>
